import { stringify } from 'qs';
import request from '@/utils/request';


export async function submit(params) {
    return request(`/api/blade-interact/supervisionFile/save`, {
      method: 'POST',
      body: params,
    });
}

export async function update(params) {
  return request(`/api/blade-interact/supervisionFile/update`, {
    method: 'POST',
    body: params,
  });
}

export async function list(params) {
    return request(
      `/api/blade-interact/supervisionFile/list?${stringify(params)}`,
    );
}